export const SCROLL_THRESHOLD = 50;

export const SCROLL_BY = 5;
